import PageHeader from "../components/PageHeader";
import { Lock, ShieldCheck } from "lucide-react";
import { useLang } from "../i18n/LanguageProvider";

export default function Portal() {
  const { t } = useLang();
  return (
    <>
      <PageHeader
        eyebrow={t("page.portal.eyebrow")}
        title={t("page.portal.title")}
        lede={t("page.portal.lede")}
      />
      <section className="pb-24">
        <div className="max-w-[900px] mx-auto px-6 lg:px-12">
          <div className="border border-[var(--bw-border)] p-10 lg:p-14">
            <div className="flex items-start gap-6">
              <Lock size={28} className="text-gold shrink-0 mt-1" strokeWidth={1.2} />
              <div>
                <h2 className="font-serif-display text-2xl text-white mb-3">Access is granted, not requested.</h2>
                <p className="text-muted leading-relaxed">
                  Access to consolidated reporting, transaction logs and family documents is
                  provisioned individually to each principal and their advisors. Credentials are
                  issued only after in-person KYC and are subject to hardware-based multi-factor
                  authentication.
                </p>
                <div className="mt-8 flex items-center gap-3 text-sm">
                  <ShieldCheck size={16} className="text-gold" strokeWidth={1.4} />
                  <span className="text-white/85">
                    For portal issues, write to{" "}
                    <a href="mailto:office@bonworldsingapore.com" className="text-gold hover:underline">
                      office@bonworldsingapore.com
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
